import * as React from "react";
import { css, cx } from "emotion";
import { getThemeColorVar } from "../helper/color";
const iconClass = css({
    fontFamily: "Revoicons",
    fontSize: "24px",
    fontWeight: "normal",
    fontStyle: "normal",
    display: "inline-block",
    textTransform: "none",
    letterSpacing: "normal",
    wordWrap: "normal",
    whiteSpace: "nowrap",
    verticalAlign: "top",
    direction: "ltr",
    webkitFontSmoothing: "antialiased",
    textRendering: "optimizeLegibility",
    fontFeatureSettings: '"liga" 1',
});
const sizeClasses = {
    small: css({
        lineHeight: 1,
        fontSize: "14px",
    }),
    regular: css({
        lineHeight: 1,
        fontSize: "24px",
    }),
    large: css({
        lineHeight: 1,
        fontSize: "34px",
    }),
    "extra-large": css({
        lineHeight: 1,
        fontSize: "44px",
    }),
    xxl: css({
        lineHeight: 1,
        fontSize: "54px",
    }),
};
export const Icon = (props) => {
    const { color, colorType, size, fontSize, name } = props;
    const classes = [iconClass];
    if (size) {
        classes.push(sizeClasses[size]);
    }
    if (color && colorType) {
        classes.push(css({ color: getThemeColorVar(color, colorType) }));
    }
    if (fontSize) {
        classes.push(css({ fontSize: `${fontSize}px`, verticalAlign: "baseline" }));
    }
    return React.createElement("i", { className: cx(classes) }, name.replace(/\s/, "_"));
};
export default Icon;
//# sourceMappingURL=icon.js.map